import React from 'react';
import { useTranslation } from 'react-i18next';
import './Header.css';

const AnnouncementBar = () => {
  const { t } = useTranslation();

  return (
    <div className="announcement-bar" role="region" aria-label="Announcement" aria-live="polite">
      <div className="announcement-bar-inner">
        <span dangerouslySetInnerHTML={{ __html: t('announcementText') }} />
      </div>
    </div>
  );
};

export default AnnouncementBar;
